import React, { useRef } from "react";
import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { QRCodeCanvas } from "qrcode.react";
import "./style.css";

const downloadVehicleQR = (container, { licensePlate, fileName }) => {
  const qrCanvas = container?.querySelector("canvas");
  if (!qrCanvas) return;

  const plate = licensePlate && licensePlate !== "-" ? licensePlate : "";
  const plateHeight = plate ? Math.round(qrCanvas.height * 0.22) : 0;
  const out = document.createElement("canvas");
  out.width = qrCanvas.width;
  out.height = qrCanvas.height + plateHeight;

  const ctx = out.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, out.width, out.height);
  ctx.drawImage(qrCanvas, 0, 0);

  if (plate) {
    ctx.fillStyle = "#111111";
    ctx.font = `bold ${Math.round(plateHeight * 0.55)}px Arial, sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(plate, out.width / 2, qrCanvas.height + plateHeight / 2);
  }

  const link = document.createElement("a");
  link.href = out.toDataURL("image/png");
  link.download = `${fileName || plate || "qr-code"}.png`;
  link.click();
};

const VehicleQRCode = ({ code, licensePlate, size = 160, showDownload = false }) => {
  const ref = useRef(null);
  const plate = licensePlate && licensePlate !== "-" ? licensePlate : "";

  if (!code) {
    return <div className="vehicle-qr__empty">QR code not yet generated</div>;
  }

  return (
    <div className="vehicle-qr" ref={ref}>
      <QRCodeCanvas
        value={code}
        size={size}
        bgColor="#ffffff"
        fgColor="#111111"
        level="H"
        includeMargin
      />
      {plate && <div className="vehicle-qr__plate">{plate}</div>}
      {showDownload && (
        <Button
          size="small"
          icon={<DownloadOutlined />}
          className="vehicle-qr__download"
          onClick={() =>
            downloadVehicleQR(ref.current, {
              licensePlate: plate,
              fileName: plate || code,
            })
          }
        >
          Download QR
        </Button>
      )}
    </div>
  );
};

export { downloadVehicleQR };
export default VehicleQRCode;
